export const ATTRIBUTE_FILTER_QUERY_KEY = 'attributeFilter';

export const BRAND_FILTER_QUERY_KEY = 'brandIds';

export const BRAND_FILTER_SLUG = 'brand';

export const BRAND_SEARCH_DEBOUNCE_MS = 300;

export const ATTRIBUTE_FILTER_COPY = {
    panelTitle: 'فیلترها',
    brandTitle: 'برند',
    mobileButton: 'فیلترها',
    categoryNavTitle: 'دسته‌بندی‌ها',
    fromDate: 'از تاریخ',
    toDate: 'تا تاریخ',
    apply: 'اعمال فیلترها',
    clearAll: 'حذف فیلترها',
    clearAttribute: 'پاک کردن',
    searchOptions: 'جستجو...',
    noOptions: 'موردی یافت نشد',
    selectedCount: (count: number) => `${count.toLocaleString('fa-IR')} انتخاب‌شده`,
    activeTitle: 'فیلترهای فعال',
    emptyResults: 'محصولی با این فیلترها پیدا نشد',
    invalidRange: 'مقدار انتخاب شده صحیح نیست',
    booleanTrue: 'بله',
    booleanFalse: 'خیر'
} as const;
